import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import { NavLink } from 'react-router-dom';
import UserPhoto from '../../../../components/user-photo/user-photo';
import LoadingOverlay from '../../../../components/loading-ovelay/loading-overlay';
import { GetProfileNew } from '../../../../services/api/profile-api';
import { LoginContext } from '../../../../services/api/authentication-api';
import { User_Logout } from '../../../../services/auth';
import './profile-panel.scss';

const ProfilePanel = () => {
    const [profile, setProfile] = useState({});
    
    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const profile = (await GetProfileNew()).data;
                if (profile === null) {
                    User_Logout();
                } else {
                    setProfile(profile);
                }
            } catch (error) {
                console.log(error);
            }
        };
        fetchProfile();
    }, []);

    return (
        <LoginContext.Consumer>
            {(state) => (
                <div className="profile-panel dashboard-container-shadow">
                    <LoadingOverlay area="profile-panel-area" />
                    <div className="profile-header">
                        <UserPhoto
                            className="profile-icon"
                            key={profile.Name}
                            photo={profile.ProfileImage}
                            name={profile.Name}
                            size={128}
                        />
                        <div className="profile-info">
                            <div className="user-full-name">{profile.Name}</div>
                            <div className="user-role">{profile.StrRole}</div>
                            <div className="user-email">{profile.Email}</div>
                        </div>
                        <NavLink to="/profile/edit">
                            <Button className="edit-profile-button btn-wide">Edit Profile</Button>
                        </NavLink>
                    </div>
                </div>
            )}
        </LoginContext.Consumer>
    );
};

export default ProfilePanel;
